export default __webpack_public_path__ + "static/media/ra-guitar-disconected.5f6b4d1f.svg";